
export default class PointGet{

    constructor(){
        this._init();
    }

    _init(){
        const $pointget = document.querySelector('.js-pointget');

        [...document.querySelectorAll('.js-btn-pointget')].forEach($btn=>{
            $btn.addEventListener('click', ()=>{
                $pointget.classList.add('-active');
            })
        });

        document.querySelector('.js-pointget__close').addEventListener('click', ()=>{
            $pointget.classList.remove('-active');
        });
    }
}